import { useTranslations } from '@vocab/react';
import { MenuItem, OverflowMenu } from 'braid-design-system';

import { JOB_TYPE } from 'src/const/app';

import translations from './MenuAction.vocab';

interface Props {
  type: 'applied' | 'saved';
  index: number;
  isWithNotes: boolean;
  handleDelete: () => void;
  handleEdit: () => void;
  handleOpenViewApplication: () => void;
}

export const MenuAction = ({
  type,
  index,
  isWithNotes,
  handleDelete,
  handleEdit,
  handleOpenViewApplication,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <OverflowMenu label={t('More options')} id={`menu-actions-${index}`}>
      {type === JOB_TYPE.applied && (
        <MenuItem
          onClick={handleOpenViewApplication}
          id={`menu-actions-view-application-${index}`}
        >
          {t('View application')}
        </MenuItem>
      )}
      <MenuItem onClick={handleEdit} id={`menu-actions-notes-${index}`}>
        {isWithNotes ? t('Edit notes') : t('Add notes')}
      </MenuItem>
      <MenuItem
        onClick={handleDelete}
        tone="critical"
        id={`menu-actions-delete-job-${index}`}
      >
        {type === JOB_TYPE.applied ? t('Delete application') : t('Delete job')}
      </MenuItem>
    </OverflowMenu>
  );
};
